export default "__VITE_ASSET__9f1ee19f__"